"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'PALACE  Premium',
    organizationId: 'VSvDgEQqzzzBQ9yL0Tcm',
    applicationKey: 'palace',
    applicationType: 'standalone',
    artistId: 'IhGzBSA1giavqTvvTQDZ4mRccgl2',
    theme: { dark: true },
    version: '1.0.0',
    ios: {
        bundleId: 'com.utoniq.palace',
        appId: '',
    },
    android: {
        bundleId: 'com.utoniq.palace',
    },
    deeplinkUrl: 'https://palace.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/2299305',
    deeplinkStg: 'palace-stg.netlify.app',
    deeplinkProd: 'palace.utoniq.com',
    custom: {
        modules: {
            membership: true,
            thread: true,
            prepaidPoint: { chargeable: true },
            liveStream: true,
            item: true,
            store: true,
            mission: true,
            preSale: true,
            event: true,
            cart: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
        ],
        globalTabs: [],
        artistTabs: ['home', 'posts', 'notifications', 'myProfile'],
    },
});
